import { useCallback } from 'react';
import { gql } from '@apollo/client';

import { useIntlContext } from '@i18n/context';
import { appName } from '@views/shared/consts';
import { SelectItem } from '@views/shared/Select/interfaces';
import { useErrorMutation } from '@providers/Errors';

const languages: SelectItem[] = [
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'de',
    label: 'Deutsch',
  },
  {
    value: 'fr',
    label: 'Française',
  },
  {
    value: 'it',
    label: 'Italiano',
  },
  {
    value: 'nl',
    label: 'Dutch',
  },
  {
    value: 'ru',
    label: 'Русский',
  },
];

const changeLangMutation = gql`
  mutation updateMeLanguage(
    $language: LanguageEnumType!
    $appName: Application!
  ) {
    updateMe(
      user: { userprofile: { language: $language } }
      appName: $appName
    ) {
      id
      userprofile {
        language
      }
    }
  }
`;

export function useLanguage(t) {
  const { lang, setAppLanguage } = useIntlContext();
  const [changeLang] = useErrorMutation(changeLangMutation, {
    finderError: {
      type: 'fatal',
      message: t('Profile.Content.Language.changeError'),
    },
  });
  const onLanguageChange = useCallback(
    async (language: string) => {
      await changeLang({
        variables: {
          appName,
          language,
        },
      });

      setAppLanguage(language);
    },
    [setAppLanguage, changeLang],
  );

  return {
    lang,
    languages,
    onLanguageChange,
  };
}
